export const initalFilters = {
  status: [
    'AGREEMENT_RENDERING',
    'CREATING_BENEFICIARY_ACCOUNT',
    'PENDING_SIGNATURE',
    'PENDING_GUARANTEE',
    'PENDING_QUALIFICATION',
    'PENDING_CESSION_QUALIFICATION',
    'PENDING_PAYMENT',
    'KYC_PROCESSING',
    'PENDING_DISBURSEMENT',
    'PARTIAL_DISBURSEMENT',
    'DISBURSEMENT_ATTEMPT_FAILED',
    'ISSUED',
    'CANCELED',
    'PENDING_RANDOM',
    'PENDING_CASHOUT',
    'PENDING_CESSION',
    'AWAITING_APPROVAL_DISBURSEMENT',
    'SIGNATURE_ERROR',
    'PENDING_ENTRY_PAYMENT',
    'CREATING_ENTRY_PAYMENT',
    'SCHEDULED_DISBURSEMENT',
    'SENDING_CONSIGNEE_CONTRACT',
    'PENDING_CONTRACT_SUBMISSION',
  ],
};

export type TFilterStatus =
  | 'AGREEMENT_RENDERING'
  | 'CREATING_BENEFICIARY_ACCOUNT'
  | 'PENDING_SIGNATURE'
  | 'PENDING_GUARANTEE'
  | 'PENDING_QUALIFICATION'
  | 'PENDING_CESSION_QUALIFICATION'
  | 'PENDING_PAYMENT'
  | 'KYC_PROCESSING'
  | 'PENDING_DISBURSEMENT'
  | 'PARTIAL_DISBURSEMENT'
  | 'DISBURSEMENT_ATTEMPT_FAILED'
  | 'ISSUED'
  | 'CANCELED'
  | 'PENDING_RANDOM'
  | 'PENDING_CASHOUT'
  | 'PENDING_CESSION'
  | 'AWAITING_APPROVAL_DISBURSEMENT'
  | 'SIGNATURE_ERROR'
  | 'PENDING_ENTRY_PAYMENT'
  | 'CREATING_ENTRY_PAYMENT'
  | 'SCHEDULED_DISBURSEMENT'
  | 'SENDING_CONSIGNEE_CONTRACT'
  | 'PENDING_CONTRACT_SUBMISSION';
